module.exports = __webpack_public_path__ + "media/images/lp_kikukawasan_interview-76eeac832abec9f11a3b0d93ef25c5f1.webp";